import React, {FunctionComponent, useEffect} from 'react'
import styles from './StatisticsPage.module.sass'
import {useRootDispatch, useRootSelector} from '../../../utils/hooks'
import RequestDropdown from '../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import {apiRequests} from '../../../http/config'
import {User} from '../../../responses/users'
import Spacer from '../../etc/Spacer'
import clsx from 'clsx'
import {Classes} from '../../../styles'
import Button from '../../controls/Button/Button'
import DownloadIcon from '../../../../files/download.svg'
import {byTaskActions} from '../../../redux/pages/statistics/byTask'
import {getId} from '../../../utils/entity-utils'
import StatisticsTable from './StatisticsTable/StatisticsTable'
import {isSome} from 'fp-ts/Option'
import {ColumnConfiguration} from './StatisticsTable/configuration'
import {ByTaskData} from '../../../responses/statistics'
//import {toBool} from '../../../utils/utils'
import {flow} from 'fp-ts/function'
import {toServerDate} from '../../../utils/date-utils'
import {fst, snd} from 'fp-ts/Tuple'
import ColumnPicker from './ColumnPicker/ColumnPicker'
import {NonEmptyArray} from 'fp-ts/NonEmptyArray'
import FiltersClearIcon from '../../../../files/filters-clear.svg'
import {Direction} from '../../../responses/refs/refs'
import {RequestStatus} from '../../../responses/response'
import TopBarProgress from 'react-topbar-progress-indicator'
import {isDefinedTuple} from '../../../utils/utils'

const configuration: NonEmptyArray<ColumnConfiguration<ByTaskData>> = [{
    group: '',
    name: '',
    render: data => data.name
},{
    group: 'Всего',
    name: 'Открыто',
    render: data => data.total.total?.opened ?? 0,
}, {
    group: 'Всего',
    name: 'Закрыто',
    render: data => data.total.total?.closed ?? 0,
},  {
    group: '2D',
    name: 'Открыто',
    render: data => data.total['2d']?.opened ?? 0,
}, {
    group: '2D',
    name: 'Закрыто',
    render: data => data.total['2d']?.closed ?? 0,
},{
    group: '3D',
    name: 'Открыто',
    render: data => data.total['3d']?.opened ?? 0,
}, {
    group: '3D',
    name: 'Закрыто',
    render: data => data.total['3d']?.closed ?? 0,
},{
    group: 'Чертеж',
    name: 'Открыто',
    render: data => data.total.chertezh?.opened ?? 0,
}, {
    group: 'Чертеж',
    name: 'Закрыто',
    render: data => data.total.chertezh?.closed ?? 0,
},{
    group: 'Digital',
    name: 'Открыто',
    render: data => data.total.digital?.opened ?? 0,
}, {
    group: 'Digital',
    name: 'Закрыто',
    render: data => data.total.digital?.closed ?? 0,
},{
    group: 'Инструкция',
    name: 'Открыто',
    render: data => data.total.instruktsiya?.opened ?? 0,
}, {
    group: 'Инструкция',
    name: 'Закрыто',
    render: data => data.total.instruktsiya?.closed ?? 0,
},{
    group: 'Кастомизация',
    name: 'Открыто',
    render: data => data.total.kastomizatsiya?.opened ?? 0,
}, {
    group: 'Кастомизация',
    name: 'Закрыто',
    render: data => data.total.kastomizatsiya?.closed ?? 0,
},{
    group: 'PrePress',
    name: 'Открыто',
    render: data => data.total.prepress?.opened ?? 0,
}, {
    group: 'PrePress',
    name: 'Закрыто',
    render: data => data.total.prepress?.closed ?? 0,
},{
    group: 'Образец',
    name: 'Открыто',
    render: data => data.total.obrazets?.opened ?? 0,
}, {
    group: 'Образец',
    name: 'Закрыто',
    render: data => data.total.obrazets?.closed ?? 0,
}, {
    group: 'Расчет',
    name: 'Открыто',
    render: data => data.total.raschet?.opened ?? 0,
}, {
    group: 'Расчет',
    name: 'Закрыто',
    render: data => data.total.raschet?.closed ?? 0,
},{
    group: 'Цветопроба',
    name: 'Открыто',
    render: data => data.total.tsvetoproba?.opened ?? 0,
}, {
    group: 'Цветопроба',
    name: 'Закрыто',
    render: data => data.total.tsvetoproba?.closed ?? 0,
},{
    group: 'Video',
    name: 'Открыто',
    render: data => data.total.video?.opened ?? 0,
}, {
    group: 'Video',
    name: 'Закрыто',
    render: data => data.total.video?.closed ?? 0,
},{
    group: 'Архив',
    name: 'Открыто',
    render: data => data.total.arkhiv?.opened ?? 0,
}, {
    group: 'Архив',
    name: 'Закрыто',
    render: data => data.total.arkhiv?.closed ?? 0,
},
]

const ProjectTab: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const {data, hide, open, sort, users, managers, directions, state} = useRootSelector(state => state.pages.statistics.byTask)
    const { brands, clients, date} = useRootSelector(state => state.pages.statistics.byClient)


    useEffect(() => {
        if (isDefinedTuple(date)) {
            dispatch(byTaskActions.data.request({
                managers: managers.map(getId),
                directions: directions.map(getId),
                users: users.map(getId),
                //compare: toBool(periods),
                brands: brands.map(getId),
                clients: clients.map(getId),
                date_from: toServerDate(fst(date)),
                date_to: toServerDate(snd(date)),
            }))
        }
    }, [dispatch, managers, directions, users, brands, clients, date])

    return <div className={styles.content}>
        {
            state === RequestStatus.FETCHING && <TopBarProgress/>
        }
        <div className={styles.header}>
            <RequestDropdown<User>
                className={styles.dropdown}
                placeholder={'Менеджер'}
                type={'multi'}
                value={managers}
                onChange={managers => dispatch(byTaskActions.setManagers(managers))}
                request={query => apiRequests.dictionary.list({
                    params: {key: 'manager'},
                    query
                })}
                render={user => user.name}
            />
            <RequestDropdown<User>
                className={styles.dropdown}
                placeholder={'Исполнитель'}
                render={user => user.name}
                request={query => apiRequests.project.tip({
                    params: {key: 'tasks_target_user'},
                    query
                })}
                type={'multi'}
                onChange={users => dispatch(byTaskActions.setUsers(users))}
                value={users}
            />
            <RequestDropdown<Direction>
                className={styles.dropdown}
                placeholder={'Направление'}
                render={direction => direction.title}
                request={query => apiRequests.dictionary.directionList({
                    query
                })}
                type={'multi'}
                onChange={directions => dispatch(byTaskActions.setDirections(directions))}
                value={directions}
            />
            <Button
                title={'Очистить фильтры'}
                onClick={() => dispatch(byTaskActions.clearFilters())}
            >
                <FiltersClearIcon/>
            </Button>
            <Spacer/>
            <div className={clsx(styles.text, Classes.f9)}>
                <div>Для выгрузки в Excel выберите столбцы,</div>
                <div>Менеджера и соответствующих Исполнителей.</div>
            </div>
            <ColumnPicker hide={hide} config={configuration} onChange={flow(byTaskActions.setHiddenColumns, dispatch)}/>
            <Button title={'Скачать в формате Excel'}>
                <DownloadIcon/>
            </Button>
        </div>
        {
            isSome(data) && <StatisticsTable
                name={'Проект'}
                data={data.value}
                config={configuration}
                hide={hide}
                open={open}
                sort={sort}
                onSortChange={flow(byTaskActions.setSort, dispatch)}
                onRowToggle={flow(byTaskActions.toggleRow, dispatch)}
            />
        }
    </div>
}

export default ProjectTab